<div class="tab-box">
    <div class="title-ind">
      <h1 class="title-tab">Invitaciones</h1>
    </div>
    
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
      <ng-container matColumnDef="concepto">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
          CONCEPTO
        </th>
        <td mat-cell *matCellDef="let invitacion">{{ invitacion.concepto }}</td>
      </ng-container>
      <ng-container matColumnDef="cliente">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>CLIENTE</th>
        <td mat-cell *matCellDef="let invitacion">{{ invitacion.cliente.nombreComercial}}</td>
      </ng-container>
      <ng-container matColumnDef="licencias">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nº LICENCIAS</th>
        <td mat-cell *matCellDef="let invitacion">{{ invitacion.numeroLicencias }}</td>
      </ng-container>
      <ng-container matColumnDef="base">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
          BASE IMPONIBLE
        </th>
        <td mat-cell *matCellDef="let invitacion">{{ invitacion.baseImponible}}€</td>
      </ng-container>
      <ng-container matColumnDef="iva">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>IVA</th>
        <td mat-cell *matCellDef="let invitacion">{{ invitacion.iva }}%</td>
      </ng-container>
      
      
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>TOTAL</th>
            <td mat-cell *matCellDef="let invitacion">{{ invitacion.precioTotal | number: '1.2-2'}}€</td>
      </ng-container>
      <ng-container matColumnDef="pagar">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>PAGAR</th>
        
            <td mat-cell *matCellDef="let invitacion"><p class= "pago-tabla" (click)="openDialog(invitacion.id)">Pagar</p></td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 15, 20]"></mat-paginator>
  </div>
